import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getAllEmploymentCertificates = () => {
  return dispatch => {
    dispatch({ type: "GET_ALL_EMPLOYMENT_CERTIFICATES_LOADING" });
    api
      .employmentCertificatesGetAll()
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
        dispatch({ type: "GET_ALL_EMPLOYMENT_CERTIFICATES_LOADING_DONE" });
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_ALL_EMPLOYMENT_CERTIFICATES_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetAllEmploymentCertificatesErrorAlertTitle",
          "Virhe kaikkien työtodistusten haussa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_ALL_EMPLOYMENT_CERTIFICATES_SUCCEEDED",
  payload: { employmentCertificates: data },
});

const operationFail = () => ({
  type: "GET_ALL_EMPLOYMENT_CERTIFICATES_FAIL"
});
